import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import logo from "../logo-transparent-background.png";
import {
  faAddressCard,
  faCode,
  faHouse,
  faThLarge,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light border">
      <Link to="/" className="navbar-brand">
        <img src={logo} alt="MileSoft.co" height={64} />
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarContent"
        aria-controls="navbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div
        className="collapse navbar-collapse justify-content-end"
        id="navbarContent"
      >
        <ul className="navbar-nav me-auto">
          <li className="nav-item">
            <Link to="/" className="nav-link">
              <FontAwesomeIcon icon={faHouse} className="mr-2 text-danger" />
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link">
              <FontAwesomeIcon icon={faUser} className="mr-2 text-danger" />
              About Us
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/services" className="nav-link">
              <FontAwesomeIcon icon={faCode} className="mr-2 text-danger" />
              Services
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/portfolio" className="nav-link">
              <FontAwesomeIcon icon={faThLarge} className="mr-2 text-danger" />
              Portfolio
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contacts" className="nav-link">
              <FontAwesomeIcon
                icon={faAddressCard}
                className="mr-2 text-danger"
              />
              Contacts
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
